export const blockIconsAndroidLightModeNew = (
	<span className='material-symbols-outlined'>light_mode</span>
);
